import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './ewan.css'

const Ewan = (props) => {
  return (
    <div className="ewan-thq-doctor-elm">
      <img
        loading="lazy"
        decoding="async"
        alt={props.imageAlt}
        src={props.imageSrc}
        className="ewan-image"
      />
      <div className="ewan-thq-heading-elm">
        <h2 className="ewan-text1">
          {props.heading1 ?? (
            <Fragment>
              <span className="ewan-text2">Dr. Audrey Smith</span>
            </Fragment>
          )}
        </h2>
      </div>
    </div>
  )
}

Ewan.defaultProps = {
  heading1: undefined,
  imageSrc: 'https://play.teleporthq.io/static/svg/placeholders/no-image.svg',
  imageAlt: 'image',
}

Ewan.propTypes = {
  heading1: PropTypes.element,
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
}

export default Ewan
